import { useRouter } from "next/router";

/**
 * 체험하기 개편판(2026-09-12) 노출 스위치. URL 에 `?new=1` 이 있으면 true.
 *
 * 개편 화면(포스터형 유형 선택 모달 등)을 운영에 조용히 올려 두고 링크로만 확인하기 위한 임시 플래그다.
 * 개편이 확정되면 이 훅과 기존 화면 분기를 함께 걷어낸다.
 *
 * ★ 정적 export 라 `router.query` 는 하이드레이션 뒤에 채워진다. 첫 렌더에서는 false 라
 *   마운트 즉시 그려지는 요소에는 쓰지 말고, 클릭 뒤 열리는 모달처럼 지연된 렌더에만 쓴다.
 */
export default function useNewPlayFlow(): boolean {
  const router = useRouter();
  return router.query.new === "1";
}
